/**
 * Finds all case-insensitive occurrences of a search term within a text
 * and wraps them in a <span class="highlight"> tag.
 *
 * @param text The original text to search within.
 * @param searchTerm The term to highlight.
 * @returns An HTML string with the search term highlighted, or the original text if no term is provided.
 */
export const highlightText = (text: string, searchTerm: string): string => {
  // If there's no text or no search term, return the original text.
  if (!searchTerm || !text) {
    return text;
  }

  // 'g' for global (all matches) and 'i' for case-insensitive.
  const regex = new RegExp(searchTerm, 'gi');

  // Replace matches with the highlighted version.
  return text.replace(
    regex,
    (match) => `<span class="highlight">${match}</span>`,
  );
};
